import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
const RootRoot = styled(Button)({
  maxWidth: 382,
  display: 'block',
  margin: 'auto'
});
export const Root = withDefaults(RootRoot, {
  color: 'aqua',
  fullWidth: true,
  size: 'lg'
});